<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: {},
    },
    casillasVerificacion: {
      type: Array,
      default: [],
    },
  },
  computed: {
    examenFisico() {
      return this.data;
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-8 w-full">
    <div class="flex flex-col gap-4 w-full">
      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">Fecha Inspección</div>
        <div class="font-bold text-right">
          {{ examenFisico.fecha_inspeccion ?? "-" }}
        </div>
      </div>
      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">Hora Inspección</div>
        <div class="font-bold text-right">
          {{ examenFisico.hora_inspeccion }}
        </div>
      </div>

      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">Fiscalizador</div>
        <div class="font-bold text-right">
          {{ examenFisico?.nombre_fiscalizador }}
          {{ examenFisico?.apellido_fiscalizador }}
        </div>
      </div>

      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">N° Sello</div>
        <div class="font-bold text-right">
          {{ examenFisico?.numero_sello ?? "-" }}
        </div>
      </div>

      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">Comentarios</div>
        <div class="font-bold text-right">
          {{ examenFisico?.comentarios ?? "-" }}
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <h1 class="!text-xl !font-bold">Casillas de verificación</h1>

      <ul class="list-disc list-inside" v-if="casillasVerificacion?.length > 0">
        <li v-for="(casilla, i) in casillasVerificacion" :key="i">
          {{ casilla?.nombre }}
        </li>
      </ul>

      <p v-else>No hay casillas disponibles</p>
    </div>
  </div>
</template>
